import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';

@Injectable()
export class ParticipantsPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService
  ) {
    super(apiService, dataService, null, inspectionFactory);
  }

  public updateParticipants(inspectionId: string, pluginId: string, participants: any): Observable<any> {
    return this.update(inspectionId, pluginId, participants).pipe(
      map((res: InspectionPlugin) => {
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pluginId: string, participants: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, null, pluginId, participants, 'Participants').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(
          plugin.postServerUrl
            ? plugin.postServerUrl
            : `/inspections/${plugin.inspectionId}/plugins/participants/${plugin.id}`,
          plugin.config
        );
      })
    );
  }

  // public addParticipants(participants: any): Observable<any> {
  //   return this.apiService.post('/participants/add', participants);
  // }

  // public getParticipants(): Observable<any> {
  //   return this.apiService.get('/participants');
  // }
}
